import useSWR from 'swr'
import { get } from 'api/api'
import { Station } from 'api/types'

export const useStations = () => useSWR<Station[]>('/stations', get)

export const useStation = (stationId: string | undefined) => {
  const stations = useStations()
  const data = stations.data?.find((station) => station.id === stationId)
  return { ...stations, data }
}
